var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    [
      _c(
        "v-row",
        { staticClass: "justify-center d-flex mt-n16" },
        [
          _c(
            "v-col",
            { staticClass: "mx-auto", attrs: { lg: "4", md: "7" } },
            [
              _c("v-card", { staticClass: "card-shadow border-radius-xl" }, [
                _c("div", { staticClass: "card-padding text-center" }, [
                  _c(
                    "h5",
                    { staticClass: "text-h5 text-typo font-weight-bold" },
                    [_vm._v("Create your account")]
                  ),
                ]),
                _c(
                  "div",
                  { staticClass: "card-padding" },
                  [
                    _c("v-text-field", {
                      class: _vm.inputClass,
                      attrs: {
                        "hide-details": "",
                        outlined: "",
                        "background-color": "rgba(255,255,255,.9)",
                        color: "rgba(0,0,0,.6)",
                        light: "",
                        height: "40",
                        placeholder: "Name",
                        autocomplete: "name",
                      },
                      model: {
                        value: _vm.name,
                        callback: function ($$v) {
                          _vm.name = $$v
                        },
                        expression: "name",
                      },
                    }),
                    _c("v-text-field", {
                      class: _vm.inputClass,
                      attrs: {
                        "hide-details": "",
                        outlined: "",
                        "background-color": "rgba(255,255,255,.9)",
                        color: "rgba(0,0,0,.6)",
                        light: "",
                        height: "40",
                        placeholder: "Email",
                        autocomplete: "email",
                      },
                      model: {
                        value: _vm.email,
                        callback: function ($$v) {
                          _vm.email = $$v
                        },
                        expression: "email",
                      },
                    }),
                    _c("v-text-field", {
                      class: _vm.inputClass,
                      attrs: {
                        type: "password",
                        "hide-details": "",
                        outlined: "",
                        "background-color": "rgba(255,255,255,.9)",
                        color: "rgba(0,0,0,.6)",
                        light: "",
                        height: "40",
                        placeholder: "Password",
                        autocomplete: "new-password",
                      },
                      on: {
                        keyup: function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          )
                            return null
                          return _vm.register()
                        },
                      },
                      model: {
                        value: _vm.password,
                        callback: function ($$v) {
                          _vm.password = $$v
                        },
                        expression: "password",
                      },
                    }),
                    _c("p", { staticClass: "text-xs text-body mt-n2 mb-2" }, [
                      _vm._v(
                        " At least 8 characters, with upper and lower case letters, a number and a symbol. "
                      ),
                    ]),
                    _c("v-checkbox", {
                      staticClass: "ma-0 checkbox-custom checkbox-thinner",
                      attrs: {
                        color: "#141727",
                        ripple: false,
                        "hide-details": "",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "label",
                          fn: function () {
                            return [
                              _c(
                                "span",
                                { staticClass: "text-typo text-body-2 ls-0" },
                                [
                                  _vm._v("I agree the "),
                                  _c(
                                    "a",
                                    {
                                      staticClass:
                                        "text-dark font-weight-bolder text-decoration-none",
                                      attrs: { href: "javascript:;" },
                                    },
                                    [_vm._v("Terms and Conditions")]
                                  ),
                                ]
                              ),
                            ]
                          },
                          proxy: true,
                        },
                      ]),
                      model: {
                        value: _vm.checkbox,
                        callback: function ($$v) {
                          _vm.checkbox = $$v
                        },
                        expression: "checkbox",
                      },
                    }),
                    _vm.errorMessage
                      ? _c(
                          "p",
                          { staticClass: "text-sm text-danger mt-2 mb-0" },
                          [_vm._v(_vm._s(_vm.errorMessage))]
                        )
                      : _vm._e(),
                    _c(
                      "v-btn",
                      {
                        staticClass:
                          "font-weight-bold text-uppercase btn-default bg-gradient-default py-2 px-6 me-2 mt-6 mb-2 w-100",
                        attrs: {
                          loading: _vm.loading,
                          disabled: !_vm.checkbox,
                          elevation: "0",
                          ripple: false,
                          height: "43",
                          color: "#5e72e4",
                          small: "",
                        },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.register()
                          },
                        },
                      },
                      [_vm._v("Sign Up")]
                    ),
                    _c("p", { staticClass: "text-sm text-body mt-3 mb-0" }, [
                      _vm._v(" Already have an account? "),
                      _c(
                        "a",
                        {
                          staticClass:
                            "text-dark text-decoration-none font-weight-bolder",
                          attrs: { href: "#/pages/authentication/login" },
                        },
                        [_vm._v("Sign in")]
                      ),
                    ]),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }